<template>
    <div>
        <vx-card title="Family Information" subtitle="Lists of Family Information"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewFamilyInformation()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeFamilyInformation">
                    <template slot="thead">
                        <vs-th>Relative Name</vs-th>
                        <vs-th>Relationship</vs-th>
                        <vs-th>Address</vs-th>
                        <vs-th>Company</vs-th>
                        <vs-th>Position</vs-th>
                        <vs-th>Connected to Firm?</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].relativeName">
                                {{ data[indextr].relativeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].relationshipId">
                                {{ relationshipName(data[indextr].relationshipId).relationshipName}}
                            </vs-td>
                            <vs-td :data="data[indextr].address">
                                {{ data[indextr].address }}
                            </vs-td>
                            <vs-td :data="data[indextr].company">
                                {{data[indextr].company}}
                            </vs-td>
                            <vs-td :data="data[indextr].positionHeld">
                                {{data[indextr].positionHeld}}
                            </vs-td>
                            <vs-td :data="data[indextr].isFirmConnectedIndicator">
                                <vs-checkbox v-model="data[indextr].isFirmConnectedIndicator" disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Family Information"
                accept-text= "Submit"
                @accept="onAddFamilyInformation"
                :is-valid="validForm"
                :active.sync="activePromptNewFamilyInformation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Relative Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="relative name" class="w-full" v-model="relativeName" placeholder="Relative Name" />
                        <span class="text-danger text-sm" v-show="errors.has('relative name')">{{ errors.first('relative name') }}</span>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Relationship</span><span style="color:red">*</span>
                        <v-select name="relationship-name" class="w-full" v-model="relationship" label="relationshipName" :options="getAllRelationshipLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Address</span><span style="color:red">*</span>
                         <vs-input name="address" class="w-full" v-model="address" placeholder="Address"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company</span>
                        <vs-input name="yearfrom-name" class="w-full" v-model="company" placeholder="Company"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Position</span>
                        <vs-input name="position-name" class="w-full" v-model="position" placeholder="Position" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm"></span>
                        <vs-checkbox name="isFirmConnectedIndicator-name" v-model="isFirmConnectedIndicator" >Firm Connected?</vs-checkbox>
                    </div>
                </div>
               
                 
               

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Family Information"
                accept-text= "Submit"
                @accept="onEditFamilyInformation"
                :is-valid="validForm"
                :active.sync="activePromptEditFamilyInformation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Relative Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="relative name" class="w-full" v-model="relativeName" placeholder="Relative Name" />
                        <span class="text-danger text-sm" v-show="errors.has('relative name')">{{ errors.first('relative name') }}</span>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Relationship</span><span style="color:red">*</span>
                        <v-select name="relationship-name" class="w-full" v-model="relationship" label="relationshipName" :options="getAllRelationshipLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Address</span><span style="color:red">*</span>
                         <vs-input name="address" class="w-full" v-model="address" placeholder="Address"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company</span>
                        <vs-input name="yearfrom-name" class="w-full" v-model="company" placeholder="Company"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Position</span>
                        <vs-input name="position-name" class="w-full" v-model="position" placeholder="Position" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm"></span>
                        <vs-checkbox name="isFirmConnectedIndicator-name" v-model="isFirmConnectedIndicator" >Firm Connected?</vs-checkbox>
                    </div>
                </div>


            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            relativeName        : '',
            relationship        : [],
            address             : '',
            position            : '',
            company             : '',
            isFirmConnectedIndicator: false,
            userId              : null,

            uid                 : null,
            activePromptNewFamilyInformation    : false,
            activePromptEditFamilyInformation    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            this.$store.dispatch('lookup/getAllRelationshipLookup')
            .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeFamilyInformation = this.uid
            
    },
    computed: {
        employeeFamilyInformation: {
           
           get() { return this.$store.state.hrms.employeeFamilyInformation },
           set(value) { this.$store.dispatch('hrms/getAllFamilyInformation',  value )}
            
        },
        validForm(){
            return this.relativeName != null &&
                this.relationship.relationshipId != null &&
                this.address != '' 
        },
       
        getAllRelationshipLookup() {
             return this.$store.state.lookup.getAllRelationshipLookup
        },
        
        relationshipName() {
            return (id) => this.$store.getters['lookup/relationshipLookup'](id)
        },
       
    },
    methods: {
        promptAddNewFamilyInformation() {
            this.activePromptNewFamilyInformation = true
        },
        onAddFamilyInformation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    relativeName            : this.relativeName,
                    relationshipId      : this.relationship.relationshipId,
                    address             : this.address,
                    company             : this.company,
                    positionHeld        : this.position,
                    isFirmConnectedIndicator : this.isFirmConnectedIndicator,
                    userId              : this.uid,
                    currentUserId       : this.$store.state.AppActiveUser.uid
                }

                this.$store.dispatch('hrms/AddFamilyInformation', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accredition Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditFamilyInformation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                  : this.id,
                    relativeName        : this.relativeName,
                    relationshipId      : this.relationship.relationshipId,
                    address             : this.address,
                    company             : this.company,
                    positionHeld        : this.position,
                    isFirmConnectedIndicator : this.isFirmConnectedIndicator,
                    userId              : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateFamilyInformation', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Family Information Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeFamilyInformation'](Id)
            this.id                     = e.id,
            this.relativeName           = e.relativeName,
            this.relationship           = this.relationshipName(e.relationshipId),
            this.address                = e.address,
            this.company                = e.company,
            this.position               = e.positionHeld,
            this.isFirmConnectedIndicator = e.isFirmConnectedIndicator,
            this.userId                 = e.userId

            this.activePromptEditFamilyInformation = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteFamilyInformation', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeFamilyInformation = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Family Information Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>